import $ from 'jquery';
import html2canvas from 'html2canvas';
let base64 = '';
const shareContent = $('.j-canvas-container').get(0);
export const generateScreenshot = async () => {
  // 设置放大倍数
  const opts = {
    scale: 2,
    useCORS: true,
    allowTaint: false,
  };
  await html2canvas(shareContent, opts).then(res => {
    base64 = res.toDataURL('image/jpg', 1);
    $('.j-shareImg').attr('src', base64).show();
  });
  $('.j-step-save').off('click').on('click',() => {
    savaPic(base64);
  })
};
const savaPic = base64 => {
  let saveA = document.createElement('a');
  $('.j-temp').html('').append(saveA);
  saveA.href = base64;
  saveA.download = 'frxxyy' + new Date().getTime();
  saveA.target = '_self';
  saveA.click();
};
